<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-alert v-if="errors" type="error">{{ errors }}</v-alert>
    <v-form @submit.prevent="dataSave()" ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" md="4">
          <v-card :loading="loadingstatus">
            <v-col class="">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      v-model="submitData.patient_id"
                      outlined
                      dense
                      label="Patient ID"
                      hide-details
                      v-on:change="getPatient()"
                  ></v-text-field>
                  <v-chip
                      v-if="error"
                      label
                      class="ma-2"
                      small
                      color="red"
                      text-color="white"
                  >
                    {{ error }}
                  </v-chip>
                  <v-chip
                      v-if="submitData.patient_name"
                      label
                      class="ma-2"
                      small
                      color="success"
                      text-color="white"
                  >
                    {{ submitData.patient_name }}
                  </v-chip>
                  <v-chip label class="ma-2" small>
                    {{ submitData.patient_phone }}
                  </v-chip>
                  <v-chip label class="ma-2" small>
                    {{ submitData.patient_sex }}
                  </v-chip>
                  <v-chip label class="ma-2" small>
                    {{ submitData.patient_dob }}
                  </v-chip>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      v-model="submitData.surgeon_id"
                      item-text="dr_name"
                      item-value="id"
                      :items="doctors"
                      label="Sergeon Name"
                      outlined
                      dense
                      v-on:change="getReports()"
                      :loading="loadingstatus"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      v-model="submitData.referral_doctor_id"
                      :items="doctors"
                      item-text="dr_name"
                      item-value="id"
                      required
                      label="Referral Doctor"
                      outlined
                      dense
                      @focusin="toggleReadonly" @focusout="toggleReadonly" :readonly="true"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      v-model="submitData.operation_id"
                      :items="operations"
                      item-text="name"
                      item-value="id"
                      required
                      label="Operation name"
                      outlined
                      dense
                      v-on:change="getReports(), getOperationID()"

                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.operation_subhead"
                      label="Operation Subhead"
                      dense
                      outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <template>
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="submitData.operation_date"
                            label="Select Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="submitData.operation_date"
                          @input="menu = false"
                          @click:date="dateSelect"
                          :min="nowDate"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                      ref="menu"
                      v-model="menu2"
                      :close-on-content-click="false"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="submitData.starting_time"
                          label="Time"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="menu2"
                        v-model="submitData.starting_time"
                        full-width
                        @click:minute="dateSelect"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-col v-bind:class="isOperationEyeBlock">
                <v-radio-group
                    row
                    v-model="submitData.eye_type"
                    :rules="rules.required"
                    required
                >
                  <template v-slot:label>
                    <div><strong>Operation Eye</strong></div>
                  </template>
                  <v-radio label="Left Eye" value="Left Eye"></v-radio>
                  <v-radio label="Right Eye" value="Right Eye"></v-radio>
                  <v-radio label="Both Eye" value="Both Eye"></v-radio>
                  <v-radio label="Not Applicable" value="--"></v-radio>
                </v-radio-group>
              </v-col>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      label="IOL"
                      v-model="submitData.iol_id"
                      :items="iol_list"
                      item-text="name"
                      item-value="id"
                      dense
                      outlined
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.iol_power"
                      label="IOL Power"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                      v-model="submitData.ot_no"
                      :items="ot_rooms"
                      item-text="name"
                      item-value="name"
                      item-key="name"
                      label="OT Rooms"
                      outlined
                      dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.cabine"
                      label="Cabin"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.amount"
                      label="OT Amount"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.due_amount"
                      label="Due Amount"
                      dense
                      outlined
                      hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>

            <v-col>
              <v-textarea v-model="submitData.note" outlined label="Note"></v-textarea>
            </v-col>
            <v-divider></v-divider>
            <v-col>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.family_member_name"
                      label="Family Member Name"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.family_contact_no"
                      label="Contact Number"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model="submitData.family_member_relation"
                      label="Relation with patient"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="submitData.counselor">
                  <v-chip color="green" text-color="white"
                  >Counselor: {{ submitData.counselor.full_name }}
                  </v-chip
                  >
                  <!-- <v-text-field
                    v-model="submitData.counselor"
                    label="Relation with patient"
                    outlined
                    dense
                  ></v-text-field> -->
                </v-col>
              </v-row>
            </v-col>
            <v-divider></v-divider>
            <v-row align="center" justify="space-around">
              <v-btn depressed color="primary" :disabled="buttonSubmit" type="submit">
                Save
              </v-btn>
              <v-btn depressed color="primary" :disabled="buttonUpdate" type="submit">
                Update
              </v-btn>
              <v-btn
                  depressed
                  color="success"
                  :disabled="buttonRegistration"
                  type="button"
                  @click="ot_registration"
              >
                Registration
              </v-btn>
              <v-btn
                  depressed
                  color="warning"
                  @click="dialog = true"
                  :disabled="buttonCancel"
                  type="button"
              >
                Cancel
              </v-btn>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="8">
          <v-btn small color="info" v-on:click="to_schedule_list">
            Back to schedule list
          </v-btn>
          <v-btn class="ms-1 mt-1 mb-1" small depressed color="warning" :disabled="OtDischargeCertificate" type="button"
                 @click="ot_discharge_certificate">
            Discharge Certificate
          </v-btn>
          <v-card>
            <template>
              <v-card-title>OT Counseling Patient</v-card-title>
              <v-data-table
                  :headers="headers"
                  :items="desserts"
                  class="elevation-1"
                  dense
                  mobile-breakpoint="0"
                  :loading="loadingstatus"
                  loading-text="Loading... Please wait"
                  disable-pagination
              >
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                          @click="getOTSchedule(item)"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          class="ma-2"
                          open
                          prepend-icon="mdi-printer"
                          color="primary"
                          label
                          outlined
                          small
                      >
                        <v-icon> mdi-plus</v-icon>
                      </v-chip>
                    </template>

                    <span>Set OT Schedule</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" persistent width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              OT Schedule Cancel: {{ submitData.id }}
            </v-card-title>
            <v-card-text>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>Schedule Date</td>
                    <td>:</td>
                    <td class="">{{ submitData.operation_date }}</td>
                  </tr>
                  <tr>
                    <td>Patient ID</td>
                    <td>:</td>
                    <td class="">{{ submitData.patient_id }}</td>
                  </tr>
                  <tr>
                    <td>Patient Name</td>
                    <td>:</td>
                    <td class="">{{ submitData.patient_name }}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>:</td>
                    <td class="">{{ submitData.status }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-text-field
                  v-model="cancelData.patient_id"
                  label="Patient ID"
                  outlined
                  dense
              ></v-text-field>
              <v-textarea
                  outlined
                  v-model="cancelData.description"
                  name="input-7-4"
                  label="Description"
                  dense
              ></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="dialog = false"> Cancel</v-btn>
              <v-btn color="primary" text @click="scheduleCancel()"> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../../js/setup";

export default {
  data() {
    return {
      dialog: false,
      isOperationEyeBlock: 'd-block',
      desserts: [],
      headers: [
        {
          text: "Operation Name",
          value: "operation.name",
        },
        {
          text: "Operation Subhead",
          value: "operation_subhead",
        },
        {
          text: "Right Eye",
          value: "variant",
        },
        {
          text: "Left Eye",
          value: "variant_1",
        },
        {text: "Amount", value: "ot_amount"},
        {text: "Note", value: "comments"},

        // { text: "Date", value: "date" },
        {text: "Doctor", value: "doctor.dr_name"},
        {text: "Action", value: "actions", sortable: false},
      ],
      cancelData: {
        schedule_id: null,
        patient_id: null,
        description: null,
        user_id: localStorage.getItem("userId"),
      },
      iol_list: [],
      submitData: {
        patient_id: null,
        surgeon_id: null,
        patient_name: null,
        patient_phone: null,
        patient_sex: null,
        patient_dob: null,
        referral_doctor_id: null,
        operation_id: null,
        operation_subhead: null,
        eye_type: null,
        operation_date: new Date().toISOString().substr(0, 10),
        starting_time: null,

        iol_id: null,
        iol_power: null,
        amount: null,
        due_amount: null,
        ot_no: null,
        cabine: null,
        note: null,

        family_member_name: null,
        family_contact_no: null,
        family_member_relation: null,

        counselor_id: null,
        counseling_id: null,
        counselor: {},
      },
      url_param: {
        counseling_id: this.$route.query.counseling_id,
        patient_id: this.$route.query.patient_id,
        schedule_id: this.$route.query.schedule_id ? this.$route.query.schedule_id : 0,
      },
      nowDate: new Date().toISOString().substr(0, 10),
      errors: null,
      error: null,
      ot_rooms: [],
      menu2: false,
      valid: true,
      doctors: [],
      operations: [],
      OtDischargeCertificate: true,
      buttonUpdate: true,
      buttonRegistration: true,
      buttonCancel: true,

      returnUrl: "",
      search: "",
      loadingstatus: true,
      loading: false,
      menu: false,
      column: null,
      patient_info: {},
      rules: {
        required: [(value) => !!value || "Required."],
        nameRules: [
          (v) => !!v || "Patient Name is required",
          (v) => (v && v.length <= 100) || "Name must be less than 100 characters",
        ],
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Schedule",
          disabled: true,
          href: "OT Schedule",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.patient_id = this.url_param.patient_id;
    if (this.url_param.schedule_id) {
      this.OtDischargeCertificate = false;
      this.buttonUpdate = false;
      this.buttonRegistration = false;
      this.buttonCancel = false;
    }

    this.initialize();
    this.getDoctors();
    this.getOperations();
    this.getOtRooms();
    this.getIOL();
    this.checkSurgeonIdType();
    this.loadingstatus = false;
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {
    buttonSubmit: function () {
      return this.desserts.length && !this.url_param.counseling_id ? true : false;
      // return this.buttonUpdate ? false : true;
    },
  },

  methods: {
    getIOL() {
      atshq
          .get("/lens/lens-active-list")
          .then((response) => {
            this.iol_list = response.data.lensProducts;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    initialize() {
      if (this.url_param.schedule_id) {
        this.getSchedule(this.url_param.schedule_id);
      }

      if (this.url_param.counseling_id) {
        atshq
            .get("/ot-module/ot-counsiling/" + this.url_param.counseling_id)
            .then((response) => {
              this.submitData.surgeon_id =parseInt(response.data.data.doctor_id);
              this.submitData.referral_doctor_id = parseInt(response.data.data.referral_doctor_id);
              this.submitData.operation_id = parseInt(response.data.data.operation_id);
              this.submitData.operation_subhead = response.data.data.operation_subhead;
              this.submitData.operation_date = response.data.data.followup_date;
              this.submitData.amount = response.data.data.ot_amount;
              this.submitData.iol_id = parseInt(response.data.data.iol);
              this.submitData.iol_power = response.data.data.iol_power;
              this.submitData.cabine = response.data.data.cabine;
              this.submitData.ot_no = response.data.data.ot_no;
              this.submitData.counselor = response.data.data.counselor;
              this.submitData.counselor_id = parseInt(response.data.data.counselor.id);
              this.submitData.counseling_id = parseInt(this.url_param.counseling_id);
              this.checkSurgeonIdType();
              this.submitData.eye_type = response.data.data.variant
                  ? response.data.data.variant
                  : response.data.data.variant_1;

            })
            .catch((e) => {
              this.errors = true;
              this.errorMessage = e;
            });
      }

      if (this.url_param.patient_id) {
        this.submitData.patient_id = this.url_param.patient_id;
        this.getPatient();
        this.getReports();
      }
    },
    toggleReadonly(event) {
      event.preventDefault()
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly')
      } else {
        event.target.setAttribute('readonly', 'readonly')
      }
    },
    checkSurgeonIdType() {
      const id = this.submitData.surgeon_id;
      if (id === null) {
        this.result = "Surgeon ID is null";
      } else if (Array.isArray(id)) {
        this.result = "Surgeon ID is an array";
      } else if (typeof id === "object") {
        this.result = "Surgeon ID is an object";
      } else {
        this.result = `Surgeon ID is of type: ${typeof id}`;
      }
    },
    getSchedule(schedule_id) {
      atshq
          .get("/ot-module/schedule/" + schedule_id)
          .then((response) => {
            this.submitData = response.data.data;
            this.submitData.surgeon_id =parseInt(response.data.data.surgeon_id);
            this.submitData.referral_doctor_id = parseInt(response.data.data.referral_doctor_id);
            this.submitData.operation_id = parseInt(response.data.data.operation_id);
            this.submitData.iol_id = parseInt(response.data.data.iol_id);
            this.submitData.counselor = response.data.data.counselor;

            if (this.submitData.status == "Registration") {
              this.buttonRegistration = true;
              this.buttonCancel = true;
            }
            if (this.submitData.status == "OT Cancel") {
              this.buttonRegistration = true;
              this.buttonUpdate = true;
              this.buttonCancel = true;
            }
            this.getPatient();
            this.getReports();
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getPatient() {
      atshq
          .get("patients/patients/get/" + this.submitData.patient_id)
          .then((response) => {
            if (response.data.data) {
              this.error = null;
              this.submitData.patient_name = response.data.data.patient_name;
              this.submitData.patient_phone = response.data.data.patient_phone;
              this.submitData.patient_sex = response.data.data.patient_sex;
              this.submitData.patient_dob = response.data.data.patient_dob;
              this.submitData.referral_doctor_id = response.data.data.referral_doctor_id

            } else {
              this.error = "Invalid Patient ID. Please Input Correct ID.";
              this.$noty.error(this.error);
              this.submitData.patient_name = null;
              this.submitData.patient_phone = null;
              this.submitData.patient_sex = null;
              this.submitData.patient_dob = null;

            }
            this.getReports();
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            console.log(e);
            // this.errors.push(e);
          });
    },
    getDoctors() {
      atshq
          .get("/doctors")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOTs() {
      atshq
          .get("/ot-module/ot")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOtRooms() {
      atshq
          .get("/ot-module/ot-room")
          .then((response) => {
            this.ot_rooms = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOperations() {
      atshq
          .get("/operations")
          .then((response) => {
            this.operations = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getOperationID() {
      if (this.submitData.operation_id == 288) {
        this.isOperationEyeBlock = 'd-none'
        this.submitData.eye_type = '--'
      } else {
        this.isOperationEyeBlock = 'd-block'
        this.submitData.eye_type = null
      }
    },
    getReports() {
      atshq
          .get(
              "ot-module/ot-counsiling-get-patient?patient_id=" +
              this.submitData.patient_id +
              "&doctor_id=" +
              this.submitData.surgeon_id +
              "&operation_id=" +
              this.submitData.operation_id
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    getAge(getage) {
      let age = parseInt(getage);
      if (age > 99) {
        this.patient_data.patient_age = 99;
      }
      age = new Date(new Date().setFullYear(new Date().getFullYear() - age));
      var months = age.getMonth() + 1;
      age = age.getFullYear() + "-" + months + "-" + age.getDate();

      this.patient_data.patient_dob = age;
    },
    getOTSchedule(item) {
      window.location.href =
          "/ot-module/schedule-create?patient_id=" +
          item.patient_id +
          "&counseling_id=" +
          item.id;
    },
    to_schedule_list() {
      window.location.href = "/ot-module/schedule";
    },
    dataSave() {

      if (this.$refs.form.validate()) {
        if (this.submitData.id) {
          let submitUrl = "ot-module/schedule/" + this.submitData.id;
          atshq
              .put(submitUrl, {
                formData: this.submitData,
                user_id: localStorage.getItem("userId"),
              })
              .then((response) => {
                // JSON responses are automatically parsed.
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
                window.location.href =
                    "/ot-module/schedule-create?schedule_id=" + response.data.data.id;
              })
              .catch((e) => {
                // this.errors.push(e);
                this.$noty.error("Oops, something went wrong!");
                this.$noty.error(" " + e);
              });
        } else {
          let submitUrl = "ot-module/schedule";
          atshq
              .post(submitUrl, {
                formData: this.submitData,
                user_id: localStorage.getItem("userId"),
              })
              .then((response) => {
                // JSON responses are automatically parsed.
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
                window.location.href =
                    "/ot-module/schedule-create?schedule_id=" + response.data.data.id;
              })
              .catch((e) => {
                this.$noty.error(" " + e.response.data.message);
              });
        }
      } else {
        // console.log("error");
        this.$noty.error("Oops, something went wrong!");
      }
    },
    ot_registration() {
      //   window.location.href =
      //     "/ot-module/schedule-create?schedule_id=" + item.id;
      // },
      var result = confirm("Are you Sure?");
      if (result) {
        //Logic to delete the item
        // console.log(item);
        atshq
            .post("ot-module/schedule-ot-registration", {
              data: {id: this.url_param.schedule_id},
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.loadingstatus = false;
              if (response.data.status == false) {
                this.$noty.error("Oops, something went wrong!");
                this.$noty.error(response.data.messages);
              } else {
                this.$noty.success(response.data.messages);
                window.location.href = "/ot-registration/" + response.data.data;
                this.getReports();
              }
            })
            .catch((e) => {
              this.errors.push(e);
            });
      }
    },
    scheduleCancel() {
      if (confirm("are you sure?")) {
        if (this.cancelData.patient_id != this.submitData.patient_id) {
          this.$noty.error("Oops, Please input valid Patient ID.");
          return false;
        }
        this.cancelData.schedule_id = this.url_param.schedule_id;
        atshq
            .post("ot-module/schedule-cancel", {
              data: this.cancelData,
              user_id: localStorage.getItem("userId"),
            })
            .then((response) => {
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.cancelData.patient_id = "";
              this.cancelData.description = "";
              this.initialize();
            }).catch((e) => {
          this.$noty.error(e.response.data.message);
          this.initialize();
        })
      }
    },
    ot_discharge_certificate() {
      window.location.href = "/ot-discharge-certificate/" + this.url_param.schedule_id;
    },
    dateSelect() {
      return true;
    },
  },
};
</script>
